"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/Button";
import { TextInput } from "@/components/ui/Field";

export function VerifySearchForm() {
  const router = useRouter();
  const [publicId, setPublicId] = useState("");

  function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (publicId.trim()) router.push(`/verify/${publicId.trim().toUpperCase()}`);
  }

  return (
    <form onSubmit={onSubmit} className="flex flex-col gap-3 sm:flex-row">
      <TextInput
        placeholder="공개 등록 ID 입력 (예: AP-1A2B3C4D5E)"
        value={publicId}
        onChange={(e) => setPublicId(e.target.value)}
        className="flex-1"
      />
      <Button type="submit">검증하기</Button>
    </form>
  );
}
